import { fetchFamilyImages } from '@gn-audio/core/api/product-catalogue/fetch-family-images';
import { fetchGroupImages } from '@gn-audio/core/api/product-catalogue/fetch-group-images';
export var fetchImages = function (productId, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroupImages(productId);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilyImages(productId);
            break;
    }
    return promise;
};
